<template>
    <PendingLiquidations></PendingLiquidations>
</template>
<script>
    import PendingLiquidations from '@/components/EmployeePendingLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            PendingLiquidations
        }
    }
</script>